// value: error code
export const merchantFormSubmitApiError = {
  INVALID_GMC_ID: 'E1001',
  CAN_NOT_INTEGRATE_WITH_ADVANCED_ACCOUNT:
    'cannot-integrate-with-advanced-account',
  INVALID_DOMAIN: 'merchant-domain-not-validated',
};
